import React from "react";
import style from "./innovationdetails.module.scss";
import { useNavigate } from "react-router-dom";

const InnovationDetails = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.container}>
        <h1>INNOVATION</h1>
        <p>
          We're changing the future! Creativity and innovation are at the heart
          of everything we do. This is why our team of developers, designers and
          strategists are always trying to think outside of the box when it
          comes to developing new products and services. Texhnext is a company
          that specializes in Design Thinking, We create products, services and
          solutions that are useful and impactful in order to solve customer
          problems.
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </div>
    </>
  );
};

const EthicsDetails = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.container}>
        <h1>ETHICS</h1>
        <p>
          We expect every member of our team to be good role models and
          exemplars of ethical behavior. We aim to demonstrate integrity and
          honesty in all our dealings both internally and externally, because
          without it we would not be able to maintain a loyal customer base, or
          provide excellent service to our clients and partners. We are
          absolutely committed to treating each other and our customers with
          respect, honesty, integrity and fairness.
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </div>
    </>
  );
};

const PassionDetails = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.container}>
        <h1>PASSION</h1>
        <p>
          Passion is one of our company values as a technological development
          company. We strongly believe that only with passion, boldness and
          commitment can we succeed. We want to create products that people will
          use every day. We want to help them achieve their goals and make their
          lives better. And we're excited to do that with you - as a partner,
          customer and member of the company.
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </div>
    </>
  );
};

const IntelligenceDetails = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.container}>
        <h1>INTELLIGENCE</h1>
        <p>
          We believe that in order to be successful, intelligence is paramount,
          and that every decision should be made with the utmost care. The more
          you know and the more experience you have, the better chance you have
          to make the right decisions when it comes to important choices. We are
          proud to be a workplace where employees can grow personally and
          professionally and make a bold impact on the world, and we work daily
          to help everyone in our company reach their fullest potential and have
          fun doing it!
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </div>
    </>
  );
};

const GritDetails = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.container}>
        <h1>GRIT</h1>
        <p>
          We know that can mean different things for different people, but at
          the heart of our operations is genuine grit for excellence. We're
          proud of our work ethic and the unique ways we go about doing things.
          Our culture reflects this—it's about what you can do for your
          customers, how hard you work, and how much you care about getting
          things done right.
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </div>
    </>
  );
};

const DriveDetails = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.container}>
        <h1>DRIVE</h1>
        <p>
          Our company values are vital to consumer product delivery, and one of
          those is drive. A drive to make your product the best in the world
          with all of your needs taken into consideration and exceed
          expectations for our customers. We want your company and all of its
          products to represent you, your business and your mission for every
          customer.
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </div>
    </>
  );
};

export {
  InnovationDetails,
  EthicsDetails,
  PassionDetails,
  IntelligenceDetails,
  GritDetails,
  DriveDetails,
};
